import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { id: "noFunctionsFound" }
const _hoisted_2 = { class: "table-header p-d-flex" }
const _hoisted_3 = { class: "p-input-icon-left p-mr-3 p-col-12" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_Button = _resolveComponent("Button")
  const _component_DataTable = _resolveComponent("DataTable")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_component_DataTable, {
    id: "functions-datatable",
    value: _ctx.filteredFunctions,
    paginator: true,
    rows: _ctx.functionsCatalogDatatableDescriptor.rows,
    loading: _ctx.loading,
    class: "p-datatable-sm kn-table kn-page-content",
    dataKey: "id",
    responsiveLayout: _ctx.functionsCatalogDatatableDescriptor.responsiveLayout,
    breakpoint: _ctx.functionsCatalogDatatableDescriptor.breakpoint,
    onRowClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('selected', $event.data)))
  }, {
    loading: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('common.info.dataLoading')), 1)
    ]),
    empty: _withCtx(() => [
      _createVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('managers.functionsCatalog.noFunctionsFound')), 1)
    ]),
    header: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode("span", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_InputText, {
            class: "kn-material-input",
            modelValue: _ctx.searchWord,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchWord = $event)),
            type: "text",
            placeholder: _ctx.$t('common.search'),
            onInput: _ctx.searchFunctions
          }, null, 8, ["modelValue", "placeholder", "onInput"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.functionsCatalogDatatableDescriptor.columns, (col) => {
        return (_openBlock(), _createBlock(_component_Column, {
          class: "kn-truncated",
          style: col.style,
          header: _ctx.$t(col.header),
          key: col.field,
          sortField: col.field,
          sortable: true
        }, {
          body: _withCtx((slotProps) => [
            _withDirectives(_createVNode("span", null, [
              _createTextVNode(_toDisplayString(slotProps.data[col.field]), 1)
            ], 512), [
              [
                _directive_tooltip,
                slotProps.data[col.field],
                void 0,
                { top: true }
              ]
            ])
          ]),
          _: 2
        }, 1032, ["style", "header", "sortField"]))
      }), 128)),
      _createVNode(_component_Column, {
        style: _ctx.functionsCatalogDatatableDescriptor.table.iconColumn.style
      }, {
        body: _withCtx((slotProps) => [
          _withDirectives(_createVNode(_component_Button, {
            icon: "fa fa-play-circle",
            class: "p-button-link",
            onClick: _withModifiers(($event: any) => (_ctx.previewFunction(slotProps.data)), ["stop"])
          }, null, 8, ["onClick"]), [
            [
              _directive_tooltip,
              _ctx.$t('managers.functionsCatalog.executePreview'),
              void 0,
              { top: true }
            ]
          ]),
          (_ctx.canDelete(slotProps.data))
            ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                key: 0,
                icon: "pi pi-trash",
                class: "p-button-link",
                onClick: _withModifiers(($event: any) => (_ctx.deleteFunctionConfirm(slotProps.data.id)), ["stop"]),
                "data-test": 'delete-button-' + slotProps.data.id
              }, null, 8, ["onClick", "data-test"])), [
                [
                  _directive_tooltip,
                  _ctx.$t('common.delete'),
                  void 0,
                  { top: true }
                ]
              ])
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }, 8, ["value", "rows", "loading", "responsiveLayout", "breakpoint"]))
}